import { Box, Grid, Typography } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import Alert from '../../../components/alert'
import useStyles from '../styles'
import {
  DisplayGardien,
  isActionRequired,
  OverParagraph,
  requiredAction,
  requiredActionDescription,
} from '../utils'
const darkGrey = '#575757'

const AlertInfos = ({ record }) => {
  const classes = useStyles()
  const translate = useTranslate()
  const isLastStep = () => {
    if (record === undefined) return false
    return (
      record.step_rank !== undefined &&
      parseInt(record.step_rank) === parseInt(record.max_rank)
    )
  }
  if (record.copro_code === undefined) {
    return null
  }
  if (isLastStep(record) === true) {
    return (
      <Grid container justifyContent="center" className={classes.spacing}>
        <Grid item xs={11} md={6}>
          <Box className={classes.paper}>
            <OverParagraph />
          </Box>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container justifyContent="center" className={classes.spacing}>
      <Grid item xs={11} md={6}>
        <Alert color="#def3ff">
          <div>
            <Typography gutterBottom="true">
              Vous avez été notifié(e) en tant que référent(e) d'une demande
              concernant la copropriété {record.copro_code}
            </Typography>
            <Typography style={{ color: darkGrey }} gutterBottom="true">
              {record.copro_name}
              <br />
              <DisplayGardien
                nom={record.fiche_gardien1_nom}
                email={record.fiche_gardien1_email}
                tel={record.fiche_gardien1_tel}
              />
              <DisplayGardien
                nom={record.fiche_gardien2_nom}
                email={record.fiche_gardien2_email}
                tel={record.fiche_gardien2_tel}
              />
            </Typography>
            <Typography style={{ color: darkGrey }} gutterBottom="true">
              Type de demande : {record.process_name.replaceAll(/s+\b/g, '')}
            </Typography>
            <Typography>
              <strong>{requiredAction(record.state_transition)}</strong>
              <br />
            </Typography>
            {isActionRequired(record.state_transition) ? (
              <Typography>
                <strong>
                  vous devez{' '}
                  {translate(
                    requiredActionDescription(
                      record.is_presta,
                      record.state_transition.description
                    )
                  ).toLowerCase()}
                  .
                </strong>
              </Typography>
            ) : (
              <div />
            )}
          </div>
        </Alert>
      </Grid>
    </Grid>
  )
}

export default AlertInfos
